import { z } from 'zod'

/**
 * Balance lives in LiteLLM: `max_budget` is everything ever topped up and
 * `spend` is everything ever consumed. The IDR figure is computed server-side
 * from the single configured rate, so the dashboard can no longer drift from
 * the rate used at checkout (V1 hardcoded 16250 in the UI).
 */
export const balanceSchema = z.object({
  balanceUsd: z.number(),
  toppedUpUsd: z.number(),
  spentUsd: z.number(),
  balanceIdr: z.number(),
  usdIdrRate: z.number(),
})

export type Balance = z.infer<typeof balanceSchema>
